import { IImagesRepo } from './interfaces/iimages.repo';
import { IPermissionsRepo } from './interfaces/ipermissions.repo';
import { ISimpleNamedEntitiesRepo } from './interfaces/isimpleNamedEntities.repo';
import { IUserRepo } from './interfaces/iuser.repo';
import { IVersionsRepo } from './interfaces/iversions.repo';

import { ImagesRepo } from './http/images.repo';
import { PermissionsRepo } from './http/permissions.repo';
import { SimpleNamedEntitiesRepo } from './http/simpleNamedEntities.repo';
import { UserRepo } from './http/user.repo';
import { VersionsRepo } from './http/versions.repo';

import { ImagesTestRepo } from './test/images.test.repo';
import { TestPermissionsRepo } from './test/permissions.test.repo';
import { TestUserRepo } from './test/user.test.repo';
import { TestVersionsRepo } from './test/versions.test.repo';


export class RepoProviderFactory {
	constructor() { }

	addProviderTypes(dependencies: any[], useTestClasses: boolean = false) {
		if (useTestClasses) {
			dependencies.push({ provide: IImagesRepo, useClass: ImagesTestRepo });
			dependencies.push({ provide: IUserRepo, useClass: TestUserRepo });
			dependencies.push({ provide: IVersionsRepo, useClass: TestVersionsRepo });
			dependencies.push({ provide: IPermissionsRepo, useClass: TestPermissionsRepo });
		} else {
			dependencies.push({ provide: IImagesRepo, useClass: ImagesRepo });
			dependencies.push({ provide: IPermissionsRepo, useClass: PermissionsRepo });
			dependencies.push({ provide: IUserRepo, useClass: UserRepo });
			dependencies.push({ provide: IVersionsRepo, useClass: VersionsRepo });
			dependencies.push({ provide: ISimpleNamedEntitiesRepo, useClass: SimpleNamedEntitiesRepo });
	
		}
	}
}
